import React from "react";

import { ContextNonprofit } from "src/context/NonprofitsContext/types";
import { colorCssVars } from "src/theme/color";
import { verticalStackCss } from "src/theme/spacing";
import { FontWeight, textSizeCss } from "src/theme/text";
import { useStatSigLayer } from "src/utility/abtesting";

export const AddTipHeader = ({
  nonprofit,
}: {
  nonprofit: ContextNonprofit;
}) => {
  const tipCopyLayer = useStatSigLayer("tip_copy_layer");
  const title = tipCopyLayer.get("title", "Choose a donation for Every.org");
  const description = tipCopyLayer.get(
    "description",
    "We are a nonprofit, so instead of charging fees we rely on the generosity of donors like you."
  );
  return (
    <div css={verticalStackCss.xs}>
      <h4 css={textSizeCss.s}>
        {title}{" "}
        <span
          css={{
            color: `var(${colorCssVars.text.secondary})`,
            fontWeight: FontWeight.REGULAR,
          }}
        >
          (optional)
        </span>
      </h4>
      <p>{description.replace("NONPROFIT", nonprofit.name)}</p>
    </div>
  );
};
